import { createAction, props } from '@ngrx/store';
const SHOW_NOTIFICATION = '[NOTIFICATION] show notification';
export const ShowNotification = createAction(SHOW_NOTIFICATION, props<{ notification: any }>());
